


































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { DxScrollView } from 'devextreme-vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import notificationService from '@/services/notificationService';
import { CompanyConfig, MailConfig } from '@/installationConfig';

import { IContactListItemDto, MailTemplatesClient, MailTemplateType, IMailTemplateDto } from '@/data/web-api-client';

import { DxForm, DxSimpleItem, DxRequiredRule, DxEmailRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import { DxHtmlEditor } from 'devextreme-vue/html-editor';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxScrollView,
    DxRequiredRule,
    DxEmailRule,
    DxHtmlEditor,
  },
})
export default class MailPopup extends Vue {
  @Prop({ required: true })
  project!: any;

  @Prop()
  initTemplate: TypeOrNull<IMailTemplateDto> = null;

  @Prop()
  mailTemplateType: TypeOrNull<MailTemplateType> = null;

  show: boolean = false;
  sending: boolean = false;
  fullscreen: boolean = false;

  formdata: any = {
    template: '',
    from: '',
    to: [],
    cc: [],
    subject: '',
    content: '',
    sendSms: false,
    objectId: '',
  };
  templates: IMailTemplateDto[] = [];

  mailTemplatesClient: MailTemplatesClient = new MailTemplatesClient(undefined, this.$axios);

  @Prop({ required: false })
  contacts!: IContactListItemDto[];

  public async open() {
    this.show = true;

    if (this.initTemplate) {
      this.formdata.template = this.initTemplate.name;
      this.formdata.content = this.replaceTags(this.initTemplate.content!);
      this.formdata.subject = this.replaceTags(this.initTemplate.subject!);
    }
  }

  async created() {
    try {
      this.templates = await this.mailTemplatesClient.getAll(this.mailTemplateType ?? MailTemplateType.Project);
    } catch {
      // do nothing
    }
  }

  async send() {
    try {
      const form: any = this.$refs.form;
      const validationResult = form.instance.validate();

      if (!validationResult.isValid) {
        notificationService.invalidForm();
        return;
      }

      this.$emit('send', this.formdata);

      this.show = false;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.sending = false;
    }
  }

  get currentUser() {
    return this.$store.getters.currentUser;
  }

  get htmlEditorOptions() {
    return {
      toolbar: {
        items: [
          'bold',
          'italic',
          'underline',
          'separator',
          'alignLeft',
          'alignCenter',
          'alignRight',
          'alignJustify',
          'separator',
          'orderedList',
          'bulletList',
          'separator',
          'link',
          'separator',
          {
            formatName: 'size',
            formatValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
          },
          {
            formatName: 'header',
            formatValues: [false, 1, 2, 3, 4, 5],
          },
        ],
      },
    };
  }

  get contactOptions() {
    return {
      dataSource: this.contacts.filter((c) => c.email && c.email != null),
      searchEnabled: true,
      remoteOperations: true,
      searchExpr: ['email', 'displayName'],
      acceptCustomValue: true,
      valueExpr: (item: any) => {
        if (!item) {
          return 'undefined';
        }

        if (typeof item === 'string') {
          return item;
        }

        return item.email;
      },
      displayExpr: (val: IContactListItemDto | string) => {
        if (!val) {
          return '';
        }

        if (typeof val === 'string') {
          return val;
        }

        if (!val.displayName) {
          return val.email;
        }
        return `${val.displayName} <${val.email}>`;
      },
      onCustomItemCreating: (args: any) => {
        args.customItem = args.text;
      },
    };
  }

  replaceTags(content: string) {
    let replacedContent = content;
    const self = this;

    let contact = null;

    if (!this.project) {
      return replacedContent;
    }
    if (this.project.contacts) {
      contact = this.project.contacts[0]?.contact;
    }
    if (this.formdata.to[0]) {
      contact = this.contacts.find((c) => c.email === this.formdata.to[0]);
    }

    while (replacedContent.indexOf('#Name') !== -1) {
      replacedContent = replacedContent.replace('#Name', contact ? contact.displayName! : '');
    }

    while (replacedContent.indexOf('#Quotation_DocumentNumber') !== -1) {
      replacedContent = replacedContent.replace('#Quotation_DocumentNumber', CompanyConfig.companyName == "OneSkin" ? this.project.documentNumber!.replace("OFF/", "")  : this.project.documentNumber!);
    }

    while (replacedContent.indexOf('#Quotation_DocumentNumber') !== -1) {
      this.formdata.subject = this.formdata.subject.replace('#Quotation_DocumentNumber', CompanyConfig.companyName == "OneSkin" ? this.project.documentNumber!.replace("OFF/", "")  : this.project.documentNumber!);
    }

    if (contact && contact.type === 'Contact') {
      const splittedName = contact.displayName ? contact.displayName.split(' ') : null;
      if (splittedName && splittedName.length > 0) {
        const firstname = splittedName[0];
        const lastname = contact.displayName!.replace(firstname, '');

        while (replacedContent.indexOf('#Contact_Firstname') !== -1) {
          replacedContent = replacedContent.replace('#Contact_Firstname', firstname);
        }

        while (replacedContent.indexOf('#Contact_Lastname') !== -1) {
          replacedContent = replacedContent.replace('#Contact_Lastname', lastname);
        }
      }
    }

    while (replacedContent.indexOf('#Contact_Firstname') !== -1) {
      replacedContent = replacedContent.replace('#Contact_Firstname', '');
    }

    while (replacedContent.indexOf('#Contact_Lastname') !== -1) {
      replacedContent = replacedContent.replace('#Contact_Lastname', '');
    }

    while (replacedContent.indexOf('#Project_Name') !== -1) {
      replacedContent = replacedContent.replace('#Project_Name', this.project.name);
    }

    while (replacedContent.indexOf('#Project_DocumentNumber') !== -1) {
      replacedContent = replacedContent.replace('#Project_DocumentNumber', this.project.projectNumber);
    }

    return replacedContent;
  }

  get fromOptions() {
    const self = this;
    return {
      dataSource: [
        MailConfig.infoMailAddress,
        MailConfig.accountingMailAddress,
        MailConfig.executionMailAddress,
        MailConfig.invoicingMailAddress,
        MailConfig.calculationMailAddress,
        this.currentUser.username,
      ],
    };
  }

  get templateOptions() {
    const self = this;
    return {
      dataSource: this.templates,
      valueExpr: 'name',
      displayExpr: 'name',
      onItemClick: (e: any) => {
        self.formdata.content = self.replaceTags(e.itemData.content);
        self.formdata.subject = self.replaceTags(e.itemData.subject);
      },
    };
  }

  @Watch('mailTemplateType', { immediate: true })
  async mailTemplateTypeWatch() {
    this.templates = await this.mailTemplatesClient.getAll(this.mailTemplateType);
  }
}
